<template>
  <div class="toast-container">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['toast', `toast-${toast.type}`, { 'toast-exit': !toast.visible }]"
      >
        <div class="toast-icon">
          <i v-if="toast.type === 'success'" class="icon-check-circle"></i>
          <i v-else-if="toast.type === 'error'" class="icon-x-circle"></i>
          <i v-else-if="toast.type === 'warning'" class="icon-alert-triangle"></i>
          <i v-else class="icon-info"></i>
        </div>
        <p class="toast-message">{{ toast.message }}</p>
        <button @click="removeToast(toast.id)" class="toast-close">
          <i class="icon-x"></i>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { useToast } from '@/composables/useToast';

export default {
  name: 'ToastContainer',
  setup() {
    const { toasts, removeToast } = useToast();

    return {
      toasts,
      removeToast,
    };
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  pointer-events: none;
}

.toast {
  background: white;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 300px;
  max-width: 400px;
  pointer-events: all;
  border-left: 4px solid;
}

.toast-success {
  border-left-color: #38a169;
}

.toast-error {
  border-left-color: #e53e3e;
}

.toast-warning {
  border-left-color: #dd6b20;
}

.toast-info {
  border-left-color: #3182ce;
}

.toast-icon {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.toast-success .toast-icon {
  color: #38a169;
}

.toast-error .toast-icon {
  color: #e53e3e;
}

.toast-warning .toast-icon {
  color: #dd6b20;
}

.toast-info .toast-icon {
  color: #3182ce;
}

.toast-message {
  flex: 1;
  margin: 0;
  color: #2d3748;
  font-size: 0.875rem;
  line-height: 1.4;
}

.toast-close {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  color: #a0aec0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.toast-close:hover {
  background: #f7fafc;
  color: #4a5568;
}

/* Transitions */
.toast-enter-active {
  animation: slideIn 0.3s ease;
}

.toast-exit,
.toast-leave-active {
  animation: slideOut 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@media (max-width: 640px) {
  .toast-container {
    left: 1rem;
    right: 1rem;
    top: 1rem;
  }

  .toast {
    min-width: 0;
    max-width: 100%;
  }
}
</style>